const PropTypes = require('prop-types');
const React = require('react');
const { formatText} = require('core/i18n').i18n;
const { InputSafe } = require('commonsComponents/inputSafe');

class InputCharsLeft extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            value: props.initialValue
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialValue !== this.state.value) {
            this.setState({
                value: nextProps.initialValue
            });
        }
    }

    handleBlur(evt) {
        this.props.callback(evt.target.value);
    }

    handleChange(evt) {
        this.setState({
            value: evt.target.value
        });
    }

    render () {
        const {id, maxLength, label, errorMessage, errorState, placeholder, onClick} = this.props;
        const charsLeft = maxLength - this.state.value.length;
        const message = formatText('transfers-charactersLeft', [charsLeft]);

        return (
            <div className="input-chars-left">
                <InputSafe
                    id={id}
                    label={label}
                    type="text"
                    autoComplete="off"
                    value={this.state.value}
                    onChange={this.handleChange}
                    onClick={onClick}
                    onBlur={this.handleBlur}
                    maxLength={maxLength}
                    instructionsMessage={message}
                    errorState={errorState}
                    errorMessage={errorMessage}
                    placeholder={placeholder}
                />
            </div>
        );
    }
}

InputCharsLeft.propTypes = {
    callback: PropTypes.func,
    id: PropTypes.string,
    maxLength: PropTypes.string,
    initialValue: PropTypes.string,
    label: PropTypes.string,
    errorState: PropTypes.bool,
    errorMessage: PropTypes.string,
    placeholder: PropTypes.string,
    onClick: PropTypes.func,
};

InputCharsLeft.defaultProps = {
    id: '',
    label: '',
    errorState: false,
    onClick: () => {}
};

module.exports = InputCharsLeft;